import { reel_branding, reel_media, reel_3dmotion, reel_uiux } from '../assets'

export const project = {
  title: { short: "lawwd", long: "Look At What We Did" },
  website: "lawwd.co",
  copyright: "© 2018-2026.", /* Droits d'auteur */
  contacts: [
    {
      label: "email", value: "contact@lawwd.co",
      onClick: "mailto:lawwdagency@gmail.com", icon: "ri-mail-fill"
    },
    /*  {
        label: "PR", value: "press@lawwd.co",
        onClick: "mailto:press@lawwd.co", icon: "ri-mail-fill"
       }, */
    {
      label: "Tel", value: "+221 77 859 22 91",
      onClick: "callto:00221778592291?prompt=true", icon: "ri-phone-fill"
    },
    {
      label: "Bureau", value: "1 Place de l'Indépendance, Dakar SN",
      onClick: "https://maps.app.goo.gl/3s9bDJFnAALRVyy48", icon: "ri-map-pin-fill"
    },
  ]
}

export const servicesList = {
  en: [
    "Brand Identity Design",
    "Media Production",
    "3D & Motion Design",
    "UI/UX Design & Dev",
    // "Product Design",
  ]
  ,
  fr: [
    "Design de marque",
    "Production Médiatique",
    // "Production Média",
    "Motion Design 3D",
    "UI/UX Design & Dev",
    // "Design de Produit ",
  ]
}

export const services = [

  { label: servicesList.fr[0], short: "Identité", reel: reel_branding,
    color: "#D0CCAD",
    icon: "ri-brush-fill",
    descr: "Des startups aux grandes entreprises, nous (re)construisons des identités fortes, intemporelles, qui laissent une empreinte durable et marquent les esprits.",
    categories: [
      {
        label: "stratégie & conseil ", contains: [
          "pitch deck", "market research", "product activation", "consultancy", "brand naming"
        ]
      },
      {
        label: "design d'identité", contains: [
          "logo design", "brand guidelines", "typescale & typography", "pattern design", "color palettes"
        ]
      },

      {
        label: "branding", contains: [
          "rebranding | revamps", "packaging design", "brand voice", "brand positioning", "R&D"
        ]
      },
      {
        label: "brand collaterals", contains: [
          "stationery kits", "goodies", "decorative branding"
        ]
      },

    ],
    keyProjects: [
      { clientRef: "amossa interior" },
      { clientRef: "macaron and co" },
    ]
  },
  { label: servicesList.fr[1], short: "Média", reel: reel_media,
    color: "#D1F8AB",
    icon: "ri-play-circle-fill",
    descr: "Votre produit et vos services méritent d'être visibles et bien représentés. Nous créons du contenu médiatique authentique, fidèle à votre marque, pour capter l'attention de votre audience cible.",
    categories: [
      {
        label: "Live Footage & CGI", contains: [
          "videography / films", "ads", "creative direction"
        ]
      },
      {
        label: "photography", contains: [
          "portraits", "landscape", "architecture", "events"
        ]
      },
      {
        label: "pre/Post production", contains: [
          "treatment / storytelling", "VFX & SFX", "styleframes", "color-grading", "voice-over"
        ]
      },

    ],
    keyProjects: [
      { clientRef: "anima iris" },
      { clientRef: "omana" },
    ]
  },
  { label: servicesList.fr[2], short: "Motion 3D", reel: reel_3dmotion,
    color: "#EB7F45",
    icon: "ri-box-3-fill",
    descr: "Que ce soit pour une campagne publicitaire, un lancement de produit, un projet interactif, ou une idée innovante à visualiser, notre expertise en 3D donne une nouvelle dimension à votre marque, créant des expériences marquantes.",
    categories: [
      {
        label: "CGI", contains: [
          "3D Moodboard", "Direction Artistique", "Motion Design", "VFX"
        ]
        // "3D modeling", "texturing", "rigging", "set design", "art direction", "animation", 'stills', "rendering"
      },
      {
        label: "Product", contains: [
          "3D modeling", "texturing", "rigging", "set design", "art direction", "animation", 'stills', "rendering"
        ]
      },
      {
        label: "Visualisation", contains: [
          "Visualisation design industriel produit", "Visualisation Données", "Architecture / Intérieur"
        ]
      },
    ],
    keyProjects: [
      { clientRef: "nakala" },
      { clientRef: "montblanc" },
      // { clientRef: "omana" },
      // { clientRef: "sanu" },
      // { title: "pr_3D_001" },
      // { title: "pr_3D_002" },
      // { title: "pr_3D_003" },
      // { title: "pr_3D_004" },
    ]
  },
  { label: servicesList.fr[3], short: "Web/App", reel: reel_uiux,
    // UI/UX
    color: "#74AFD9",
    icon: "ri-global-fill",
    descr: `Nous ne nous contentons pas de concevoir des interfaces esthétiques – nous créons des expériences fluides, intuitives et engageantes, qui transforment la manière dont vos utilisateurs interagissent avec votre marque.`,

    categories: [
      {
        label: "UI/UX Design", contains: [
          "Recherche", "Prototype Interactif", "Conception MVP", "Design Systems", "Architecture projet",
        ]
      },
      {
        label: "Design & Dev </>", contains: [
          "frontend / backend", 'web/app', "cyber security"
        ]
      },
      {
        label: "Frameworks", contains: [
          "React JS", "Next JS", "WebFlow", "Flutter", "Angular", "Wordpress", "Figma"
        ]
      },
    ],
    keyProjects: [
      { clientRef: "appwrite" },
      { clientRef: "ISIF dakar business school" },
      // { clientRef: "lucid" },
    ]
  },
/*   { label: servicesList.fr[4], short: "Design Produit", reel: reel_uiux,
    color: "#74AFD9",
    icon: "ri-ink-bottle-fill",
    descr: `Nous croyons que des marques fortes se distinguent par leurs produits. C’est pourquoi nous apportons une touche de fraîcheur au packaging, optimisons l’ergonomie, et concevons des objets alliant esthétique et fonctionnalité, de l’idéation à la production.`,
    categories: [
      {
        label: "Technical R&D", contains: [
          "Recherche", "Prototype Produit", "Conception MVP",
        ]
      },
      {
        label: "Brand & Packaging", contains: [
          "frontend / backend", 'web/app', "cyber security"
        ]
      },
      {
        label: "Product Visualisation", contains: [
          "React JS", "Next JS", "WebFlow", "Flutter", "Angular", "Wordpress", "Figma"
        ]
      },
      {
        label: "Marketing", contains: [
          "Activation produit", "Catalogue Produit",
        ]
      },
    ],
    keyProjects: [
      { clientRef: "blender" },
      { clientRef: "fold" },
      // { clientRef: "lucid" },
    ]
  } */

]

export const practice = {
  en: [
    "creative consultancy",
    "creative R&D",
    "design thinking",
    "business development",
    "marketing",
    "project management",
    "entrepreneurship",
  ],
  fr: [
    "expertise 360 en Affaires de Marque",
    "conseil en créativité",
    "R&D créative",
    "design thinking",
    "développement des affaires",
    "marketing",
    "management de project",
    "entrepreneuriat",
  ]
}

export const latestProjects = [
  // "isif dakar business school",
  "annagram",
  "mela label",
  "yellow",
  // "nakala",
  // "montblanc",
]

export const partners = [
  "Senegal.gov",
  "So'Fatoo",
  "Nike",
  "Zara",
  "Samsung",
  // "Layepro Consulting",
  "Institut Africain de Management",
]

export const zones = [
  {
    label: "West & North Africa ", size: 'large', groups: [
      "Senegal", "Mali", "Conakry", "Ivory Coast"
    ], length: 22, pin: { x: 43, y: 45 }
  },
  {
    label: "South Africa", groups: [
      "South Africa",
    ], length: 1, pin: { x: 54.7, y: 78 }
  },
  {
    label: "America", groups: [
      "United States", "Brazil", "Mexico"
    ], length: 3, pin: { x: 15, y: 30 }
  }
]

export const challenges = {
  s: {
    title: 'Des défis relevés🏆',
    descr: "Tout ne se passe pas toujours dans le plus grand des calmes. L'enjeu en vaut le sacrifie. Il vient un moment où l'esprit jambaar, la tenacité sont les clés d'un déroulement à succès."
  },
  data: [
    {
      title: "Launch express d'une startup tech en 8H",
      sub: "TeewTickets",
      // "Le ticket d'une mission impossible",
      descr: "En une nuit, nous avons recherché, conceptualisé et produit l'identité intricate de TeewTickets. Une StartUp de billeterie digitale au Sénégal. Une première pour le pays, étant l'initiative de deux jeunes entrepreneurs visionnaires.",
      refProject: "teewTickets"
    },
    {
      title: <>Eviter une perte de 8&nbsp;000&nbsp;0000 fcfa à un client </>,
      sub: "Teranga Fest",
      descr: "Moussa Diop’s Teranga Fest was on the brink of losing 8 million CFA due to a failed rebrand and poor marketing. In desperation, he turned to LAWWD. We swiftly revamped the festival’s identity, launched a high-impact digital campaign, and secured lost sponsors. Within weeks, ticket sales skyrocketed by 180%, and the event sold out. Instead of losing money, Moussa’s company profited 15 million CFA. LAWWD once again proved its power in saving and elevating brands.",
      refProject: "nakala"
    },
    {
      title: <>The 12-Hour Turnaround: How LAWWD Saved a Last-Minute Product Launch </>,
      sub: "Teranga Fest",
      descr: "A Dakar-based startup, Baobab Tech, was set to launch its new fintech app but faced a disaster—its marketing agency failed to deliver the campaign materials just 12 hours before launch. Panicked, CEO Aïcha Fall called LAWWD for an emergency fix. The team worked overnight, creating a high-impact launch video, an email marketing blitz, and a social media ad campaign. By morning, the app went live flawlessly, gaining 5,000 downloads in the first 48 hours. What could’ve been a failure turned into a record-breaking launch, all thanks to LAWWD’s agility and expertise.",
      refProject: "macaron and co"
    },
  ]
};
